module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footerlist"
  }, [_c('h3', {
    staticClass: "footerlist__title"
  }, [_vm._v(_vm._s(_vm.title))]), (_vm.list.length) ? _c('ul', {
    staticClass: "footerlist__list"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "footerlist__item"
    }, [_c('p', {
      staticClass: "footerlist__text"
    }, [_vm._v(_vm._s(item))])])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88008256","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/modules/modulefooter/components/modulefooterlist/ModuleFooterList.vue
// module id = f9954737a9c7a69370ab
// module chunks = 0